import { useQuery, gql } from '@apollo/react-hooks';
import type { GetFindingListQuery, GetFindingListQueryVariables } from '#/graphql/types';
import { getFindingList } from '#/graphql/queries';

const q = gql(getFindingList);

const useFindingListQuery = (variables?: GetFindingListQueryVariables) => {
  const result = useQuery<GetFindingListQuery, GetFindingListQueryVariables>(q, {
    variables,
    fetchPolicy: 'cache-and-network',
  });

  return result;
};

export default useFindingListQuery;
